import type { TOTP } from '../types';

export const getTOTPDuration = (totp: TOTP) => totp.validityEnd - Date.now() / 1000;
